import { Pipe, PipeTransform } from '@angular/core';
import { Nexus } from '@tomandco/nexus-api-types';

@Pipe({
    name: 'pushCountriesToFront',
    standalone: true
})
export class PushCountriesToFrontPipe implements PipeTransform {
    transform(countries: Nexus.Lib.General.Country[], codes: string[]) {
        return pushCountriesToFront(countries, codes);
    }
}

export function pushCountriesToFront(countries: Nexus.Lib.General.Country[], codes: string[]) {
    const _countries: Nexus.Lib.General.Country[] = [...countries]; // immutable
    const removed = _countries.filter(country => !codes.includes(country.code));

    const added = _countries.filter(country => codes.includes(country.code)).sort((a, b) => codes.indexOf(a.code) - codes.indexOf(b.code));

    return [...added, ...removed];
}
